<template>
    <div :class="'page-' + entity">
        <el-dialog
                :title="(editMode ? 'Редактировать' : 'Добавить') + ' ' + message.entityToDo"
                :visible.sync="addVisible"
                width="456px"
        >
            <div>
                <el-form class="m-t-10" ref="validationForm" :model="model" v-loading="loading">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Группа" prop="Name" :rules="[{ required: true, message: 'Имя группы не заполнено' }]">
                                <el-input v-model="model.Name" placeholder="Введите имя группы"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Макс. клиентов" prop="MaxAllowedClients">
                                <el-input v-model="model.MaxAllowedClients" placeholder="Введите максимальное количество клиентов"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="p-b-10  m-t-30">
                    <el-row :gutter="20">
                        <el-col :span="12" align="left" class="d-flex align-items-left">
                            <el-button class="m-l-20" type="link" @click="addVisible = false">Закрыть</el-button>
                        </el-col>
                        <el-col :span="12" align="right" class="d-flex align-items-right">
                            <el-button type="primary" class="w-100" @click="add" :loading="loading">{{(editMode ? 'Сохранить' : 'Добавить')}}</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>

        <el-card shadow="never">
            <el-row :gutter="20">
                <el-col :sm="24" :md="12" :lg="18" :xl="18" class="m-b-10 m-b-md-0">
                    <el-input class="w-100"
                              :placeholder="message.placeholder"
                              v-model="form.SearchString"
                              v-on:change="getData"
                              clearable>
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </el-col>
                <el-col :sm="24" :md="12" :lg="6" :xl="6" align="right" class="d-flex">
                    <el-button class="w-50" type="primary" @click="handleFilter" icon="icon-search">Поиск</el-button>
                    <el-button class="w-50" @click="callForm(true)" icon="icon-plus">Добавить</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-table v-loading="loading" :data="dataTable">
                    <el-table-column prop="ID" label="ID" width="80px" sortable />
                    <el-table-column prop="Name" label="Группа" sortable>
                        <template slot-scope="scope">
                            <div class="font-weight-bold">
                                {{ scope.row.Name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="MaxAllowedClients" label="Макс. количество клиентов" sortable />
                    <el-table-column
                            fixed="right"
                            label="Действия"
                            width="120px"
                            align="right"
                    >
                        <template slot-scope="scope">
                            <el-button @click="callForm(true, scope.row)" icon="icon-edit-2" class="el-button--icon" size="mini" title="Редактировать"></el-button>
                            <el-button @click="deleteItem(scope.row.ID)" icon="icon-trash" class="el-button--icon" size="mini" title="Удалить"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="m-t-20 m-b-20 text-center">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="form.Page"
                            :page-sizes="[10, 20, 100, 200, 300, 400]"
                            :page-size="form.PageSize"
                            layout="sizes, prev, pager, next, total"
                            :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        data () {
            return {
                entity: 'CustomerGroup',
                message: {
                    entityToDo: 'группу клиентов',
                    addSuccess: 'Группа добавлена',
                    editSuccess: 'Группа изменена',
                    deleteSuccess: 'Группа удалена',
                    placeholder: 'Поиск по группам клиентов'
                },
                loading: false,
                form: {
                    SearchString: '',
                    Page: 1,
                    PageSize: 20
                },
                model: {
                    Name: '',
                    Amount: ''
                },
                total: 0,
                dataTable: [],
                addVisible: false,
                editMode: false
            }
        },
        created () {
            this.getData()
        },
        methods: {
            handleSizeChange (val) {
                this.form.PageSize = val
                this.getData()
            },
            handleCurrentChange (val) {
                this.form.Page = val
                this.getData()
            },
            handleFilter () {
                this.getData()
            },
            getData () {
                this.loading = true

                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: this.entity
                }, this.form)

                this.$api.Config.getCustomerGroup(request).then(response => {
                    this.loading = false
                    this.dataTable = response.Items
                    this.total = response.Total
                }).catch (() => {
                    this.loading = false
                })
            },
            add () {
                this.$refs['validationForm'].validate((valid) => {
                    if (valid) {
                        this.clearFormErrors('validationForm')
                        this.loading = true

                        if (this.editMode) {
                            let request = {
                                Name: 'SetItemProperties',
                                ItemType: this.entity,
                                ItemId: this.model.ID,
                                ItemProperties: Object.entries(this.model).map(row => {
                                    return {
                                        ItemPropertyName: row[0],
                                        ItemPropertyValue: row[1]
                                    }
                                })
                            }
                            this.$api.Config.editCustomerGroup(request).then(response => {
                                this.loading = false
                                if (response.Result === "Success") {
                                    this.$message({ message: this.message.editSuccess, type: 'success', res: response })
                                    this.addVisible = false
                                    this.getData()
                                }
                                else {
                                    this.$message({ message: response.ErrorString, type: 'error', res: response })
                                }
                            }).catch((error) => {
                                this.loading = false
                                this.showFormErrors(error, 'validationForm')
                            })
                        }
                        else {
                            let request = Vue.$props('AddItem', this.entity, this.model)
                            this.$api.Config.addCustomerGroup(request).then(response => {
                                this.loading = false
                                if (response.Result === "Success") {
                                    this.$message({ message: this.message.addSuccess, type: 'success', res: response })
                                    this.addVisible = false
                                    this.getData()
                                }
                                else {
                                    this.$message({ message: response.ErrorString, type: 'error', res: response })
                                }
                            }).catch((error) => {
                                this.loading = false
                                this.showFormErrors(error, 'validationForm')
                            })
                        }
                    }
                })
            },
            callForm (open, row) {
                this.resetForm()
                setTimeout(() => this.clearFormErrors('validationForm'), 1)
                this.editMode = (row ? true : false)
                this.model = (row ? {...row} : {})
                this.addVisible = open
            },
            resetForm () {
                this.model = {
                    Name: '',
                    MaxAllowedClients: ''
                }
            },
            deleteItem (id) {
                this.$confirm('Вы уверены что хотите удалить ' + this.message.entityToDo + '?', {
                    confirmButtonText: 'Удалить',
                    cancelButtonText: 'Отмена',
                    type: 'warning'
                }).then(() => {
                    let request = {
                        Name: "RemoveItem",
                        ItemType: this.entity,
                        ItemId: id
                    }

                    this.$api.Config.deleteCustomerGroup(request).then(response => {
                        if (response.Result === 'Failed') {
                            this.$message({
                                message: response.ErrorString,
                                type: 'error'
                            })
                        }
                        else {
                            this.$message({
                                message: this.message.deleteSuccess,
                                type: 'success',
                                res: response
                            })
                            this.getData()
                        }
                    })
                })
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .el-tabs--border-card > .el-tabs__content {
        padding: 0 !important;
    }
</style>
